var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pickup-filters-actions" },
    [
      _c("ui-input", {
        staticClass: "pickup-filters-actions__query",
        attrs: {
          value: _vm.value.query,
          clearable: "",
          placeholder: "Введите адрес или метро"
        },
        on: { input: _vm.onInputQuery },
        scopedSlots: _vm._u([
          {
            key: "prepend",
            fn: function() {
              return [
                _c("f-sprite-icon", {
                  attrs: { "icon-link": _vm.$options.icons.IconSearch.id }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("ui-button", {
        staticClass: "pickup-filters-actions__btn",
        attrs: {
          secondary: "",
          text: "Фильтры",
          count: _vm.countActiveFilters,
          icon: _vm.$options.icons.IconFilter.id
        },
        on: {
          click: function($event) {
            return _vm.$emit("click")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }